import { Animated } from 'react-native';
import DNABox from './DNABox';
const AnimatedDNABox = Animated.createAnimatedComponent(DNABox);
export default AnimatedDNABox;
//# sourceMappingURL=AnimatedDNABox.js.map